<template>
  <v-btn color="primary" @click="confirmSyncStatus">確認する</v-btn>
</template>

<script>
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'

export default {
  name: 'SyncStatusConfirmButtonContainer',
  props: {
    sessionId: {
      type: Number,
      required: true
    }
  },
  methods: {
    confirmSyncStatus () {
      this.$store.dispatch('LoaderStore/displayLoader')
      axios
        .patch(`/api/onamae_mm_sessions/${this.sessionId}`)
        .then(({ data }) => {
          const payload = {
            status: 200,
            message: '確認完了しました。'
          }
          this.$emit('update-session', deserialize(data).data)
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        })
        .catch((error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        })
        .finally(() => {
          this.$store.dispatch('LoaderStore/hideLoader')
        })
    }
  }
}
</script>
